// src/components/common/UserAvatar.tsx
import React, { useState } from 'react';
import { useAvatarCache } from '../../hooks/useAvatarCache';

interface UserAvatarProps {
  src?: string;
  alt?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  fallbackInitial?: string;
}

const sizeClasses = {
  xs: 'w-4 h-4',
  sm: 'w-8 h-8',
  md: 'w-12 h-12',
  lg: 'w-16 h-16',
  xl: 'w-24 h-24',
};

const UserAvatar: React.FC<UserAvatarProps> = ({
  src,
  alt = 'User',
  size = 'md',
  className = '',
  fallbackInitial,
}) => {
  const cachedSrc = useAvatarCache(src);
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div
      className={`rounded-full overflow-hidden flex-shrink-0 relative bg-gradient-to-br from-gray-200 to-gray-300 ${sizeClasses[size]} ${className}`}
    >
      {/* Fallback - always rendered */}
      <div className="absolute inset-0 flex items-center justify-center">
        <span className={`text-white font-medium ${
          size === 'xs' ? 'text-[8px]' :
          size === 'sm' ? 'text-xs' :
          size === 'md' ? 'text-sm' :
          size === 'lg' ? 'text-lg' : 'text-2xl'
        }`}>
          {fallbackInitial || alt.charAt(0).toUpperCase()}
        </span>
      </div>
      {/* Image - starts hidden, shown on load */}
      {cachedSrc && (
        <img
          src={cachedSrc}
          alt={alt}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
          onLoad={() => setIsLoaded(true)}
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
          onContextMenu={(e) => e.preventDefault()}
          draggable={false}
        />
      )}
    </div>
  );
};

export default UserAvatar;
